module.exports = __webpack_public_path__ + "static/media/GageLogo.6ef53554.svg";